// extracted by mini-css-extract-plugin
module.exports = {"stopper":"style_stopper__2lQCq"};